import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Minimal layout for onboarding/setup pages.
 * Centered content, logo at top, no sidebar or nav.
 * Auth-gated: redirects to /auth if not logged in.
 */
export const SetupLayout = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/30">
      <div className="mx-auto max-w-lg w-full px-4 py-12">
        {/* TBD Logo */}
        <div className="flex justify-center mb-10">
          <span className="text-2xl font-bold tracking-tight text-foreground">
            TBD
          </span>
        </div>

        <Outlet />
      </div>
    </div>
  );
};
